import React, { useState, useEffect } from 'react';
import { func, string, object, array, bool } from 'prop-types';
import { get, head, replace, size, split, includes, omit, trim, map, toString, isEmpty } from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';
import { Divider, FlexContainer, DrawerError, If, ConfirmFooterButtons } from '../../common';
import { Mutation } from '../../graphql';
import OriginalShipping from './OriginalShipping';
import NewShipping from './NewShipping';
import ModificationRealized from './ModificationRealized';
import UPDATE_SHIPPING_DATA from '../../../queries/UPDATE_SHIPPING_DATA';
import { withFirebase } from '../../../hoc';
import NewShippingMassive from './NewShippingMassive';

const ModifyShipping = ({
    onCancel,
    logisticsInfo,
    storeName,
    selectedAddress,
    customer,
    orderStatus,
    orderId,
    email,
    firebasePerformance,
    salesChannel,
    client,
    fromMassiveActions,
    orderIds,
    storeKind,
    session,
    isCapacity,
    createdAt
}) => {
    const status = parseInt(get(orderStatus, 'code', -1));
    const shippingType = get(logisticsInfo, 'selectedSla', 'Unknown');
    const [customerAddress, setCustomerAddress] = useState(null);
    const [shippingStore, setShippingStore] = useState(null);
    const [shippingTime, setShippingTime] = useState(null);
    const [shippingDate, setShippingDate] = useState(moment());
    const [modifyRealized, setModifyRealized] = useState(false);
    const [responseData, setResponseData] = useState({});
    const [comments, setComments] = useState(null);
    const shippingStoreLabel = get(shippingStore, 'data.title');
    const shippingDateLabel = moment(head(shippingDate)).format('YYYY-MM-DD');
    const shippingTimeLabel = get(shippingTime, 'label');
    const [traceModifyShipping, setTraceModifyShipping] = useState({});
    const isExpress = includes(shippingType, 'Express');
    const isHomeDelivery = includes(shippingType, 'Domicilio');
    const isEspecial = includes(shippingType, 'Especial');
    const isSpid = storeKind === 'SPID35';

    const confirmButtonDisabled = () => {
        const hasData = element => size(element) > 0;
        const shippingStoreLabel = get(shippingStore, 'label', null);
        const hasShippingStoreLabel = shippingStoreLabel && shippingStoreLabel !== 'NaN';
        const validateAddress = (isHomeDelivery || isEspecial) ? !isEmpty(get(customerAddress, 'data')) : true;
        const commonFieldValidate = hasShippingStoreLabel && shippingDate && hasData(shippingTime) && hasData(comments)
        const isCompleteData = validateAddress && commonFieldValidate

        if (fromMassiveActions) return !commonFieldValidate
        if (isExpress) return !(hasShippingStoreLabel && hasData(comments));
        if (isCapacity) return !(isCompleteData && get(shippingTime, 'courierName', null));
        return !isCompleteData;
    };

    useEffect(() => {
        // Firebase: Starts the timing for the trace instance
        get(traceModifyShipping, 'state') === 1 && traceModifyShipping.start();
    }, [traceModifyShipping]);

    useEffect(() => {
        // Firebase: Stop the timing for the trace instance
        modifyRealized === true && traceModifyShipping.stop();
    }, [modifyRealized]);

    const originalShipping = [
        {
            label: 'Modo de entrega',
            value: get(logisticsInfo, 'selectedSla', 'Unknown')
        },
        {
            label: 'Tienda',
            value: storeName
        },
        {
            label: 'Dirección',
            value: get(selectedAddress, 'addressLine', 'Unknown')
        },
        {
            label: 'Fecha de envío',
            value: moment(get(logisticsInfo, 'shippingETA'), 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY')
        },
        {
            label: 'Horario',
            value: moment(get(logisticsInfo, 'shippingETA'), 'YYYY-MM-DD HH:mm').format('HH:mm')
        },
        {
            label: 'Transportadora',
            value: get(logisticsInfo, 'deliveryIds[0].courierName', '')
        }
    ];

    const newShipping = [
        {
            label: 'Tipo de envío',
            value: shippingType
        },
        {
            label: 'Dirección',
            value: get(customerAddress, 'label')
        },
        {
            label: 'Tienda',
            value: get(shippingStore, 'label')
        },
        {
            label: 'Fecha de envío',
            value: shippingDateLabel
        },
        {
            label: 'Horario',
            value: shippingTimeLabel
        }
    ];

    const spidCapacityCourier = () => {
        const storeNameSplitted = split(shippingStoreLabel, ' - ');
        return storeNameSplitted[1] || storeNameSplitted[0];
    };

    const address = isExpress ? selectedAddress : get(customerAddress, 'data');

    const body = {
        status,
        email,
        idOrders: fromMassiveActions ? orderIds : [orderId],
        selectedSLA: trim(shippingType),
        date: shippingDateLabel,
        time: isSpid && isExpress ? moment(createdAt).format('HH:mm') : replace(get(shippingTime, 'value'), ' - ', '-'),
        courierName: isExpress ? spidCapacityCourier() : get(shippingTime, 'courierName', null),
        courierId: isExpress ? spidCapacityCourier() : get(shippingTime, 'courierId', null),
        salesChannelsInfo: {
            title: shippingStoreLabel,
            id: get(shippingStore, 'data.id'),
            comercial_policy: get(shippingStore, 'data.comercial_policy'),
            slaType: get(shippingStore, 'data.slaType')
        },
        address: includes(shippingType, 'Despacho') ? {
            addressType: get(address, 'addressType'),
            receiverName: get(address, 'receiverName'),
            addressName: get(address, 'addressName'),
            postalCode: get(address, 'postalCode'),
            city: get(address, 'city'),
            state: get(address, 'state'),
            country: get(address, 'country'),
            street: get(address, 'street'),
            number: get(address, 'number'),
            neighborhood: get(address, 'neighborhood'),
            complement: get(address, 'complement'),
            reference: get(address, 'reference'),
            geoCoordinates: map(get(address, 'geoCoordinates'), (item) => toString(item))
        } : null,
        comment: isSpid && isExpress
            ? `Se ha modificado la información de entrega de la tienda ${storeName} a la tienda ${shippingStoreLabel}. Motivo: ${comments}`
            : `Se ha modificado la información de entrega de ${shippingType} de la tienda ${storeName} del día ${moment(get(logisticsInfo, 'shippingETA'), 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY')} ventana ${moment(get(logisticsInfo, 'shippingETA'), 'YYYY-MM-DD HH:mm').format('HH:mm')} - ${moment(get(logisticsInfo, 'shippingETAend'), 'YYYY-MM-DD HH:mm').format('HH:mm')} a ${shippingType} de la tienda ${shippingStoreLabel} del día ${moment(head(shippingDate)).format('DD-MM-YYYY')} ventana ${shippingTimeLabel}. Motivo: ${comments}`,
        isCapacity,
        isSpid: isExpress && isSpid
    };

    return (
        <FlexContainer direction='column' flex={1} overflowY style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 115px)' }} mR={0}>
            <Mutation
                mutation={UPDATE_SHIPPING_DATA}
                refetchQueries={() => setTimeout(() => client.reFetchObservableQueries(), 5000)}
                onError={<DrawerError onCancel={onCancel} />}
            >
                {({ loading, updateFn }) => {
                    const commonProperties = {
                        salesChannel,
                        setShippingStore,
                        logisticsInfo,
                        shippingType,
                        shippingStore,
                        shippingDate,
                        onChangeShippingDate: shippingDate => setShippingDate(shippingDate),
                        shippingTime,
                        onChangeShippingTime: shippingTime => setShippingTime(shippingTime),
                        onChangeComments: comments => setComments(comments)
                    };
                    const newShippingProperties = {
                        orderId,
                        selectedAddress,
                        setCustomerAddress,
                        customerAddress,
                        storeKind,
                        session,
                        isCapacity
                    };
                    return (
                        <If
                            condition={modifyRealized === true}
                            then={<ModificationRealized data={newShipping} responseData={responseData} fromMassiveActions={fromMassiveActions} onCancel={onCancel} />}
                            else={<>
                                {!fromMassiveActions ? (<>
                                    <OriginalShipping data={originalShipping} />
                                    <Divider insideDrawer />
                                    <NewShipping
                                        userProfileId={get(customer, 'userProfileId', null)}
                                        {...newShippingProperties}
                                        {...commonProperties}
                                    />
                                </>) : <NewShippingMassive {...commonProperties} />}
                                <ConfirmFooterButtons
                                    confirmDisabled={confirmButtonDisabled()}
                                    onConfirm={() => {
                                        setTraceModifyShipping(firebasePerformance.trace('MODIFY_SHIPPING'));
                                        updateFn({
                                            variables: {
                                                input: fromMassiveActions ? omit(body, ['address']) : body
                                            }
                                        }).then(({ data }) => {
                                            setModifyRealized(true);
                                            setResponseData(data);
                                        });
                                    }}
                                    onCancel={() => onCancel()}
                                    loading={loading}
                                />
                            </>}
                        />
                    );
                }}
            </Mutation>
        </FlexContainer>
    );
};

ModifyShipping.propTypes = {
    logisticsInfo: object,
    orderStatus: object,
    onCancel: func,
    storeName: string,
    selectedAddress: object,
    customer: object,
    orderId: string,
    email: string,
    firebasePerformance: object,
    orderIds: array,
    fromMassiveActions: bool,
    salesChannel: object,
    client: object,
    isCapacity: bool,
    storeKind: string,
    session: object,
    createdAt: string
};

export default withFirebase(withApollo(ModifyShipping));
